module.exports = (theme) => ({
  ".image-block": {
    maxWidth: theme("screens.lg"),
    marginTop: theme("spacing.2xl"),
    marginBottom: theme("spacing.2xl"),
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "21px",
    paddingRight: "21px",
  },
  ".image-block figcaption": {
    marginTop: theme("spacing.xs"),
    lineHeight: "20px",
    fontSize: theme("fontSize.sm"),
    marginLeft: "0",
  },
  ".image-block-small": { marginBottom: "56px" },
  ".image-block-small figure": { display: "flex", alignItems: "flex-start" },
  ".image-block-small figcaption": {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: theme("spacing.xl"),
    marginRight: theme("spacing.xl"),
    flexShrink: 0,
    width: "131px",
  },
  [`@media (max-width: ${theme("screens.lg")})`]: {
    ".image-block": { padding: "0" },
    ".image-block figcaption": { marginLeft: "21px" },
    ".image-block-small": { padding: "0 21px", marginBottom: theme("spacing.2xl") },
    ".image-block-small figure": { display: "block" },
    ".image-block-small figcaption": {
      marginTop: theme("spacing.xs"),
      marginLeft: "0",
      marginRight: "0",
      width: "auto",
    },
  },
  [`@media (max-width: ${theme("screens.xs")})`]: {
    ".image-block": {
      marginTop: theme("spacing.xl"),
      marginBottom: theme("spacing.xl"),
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
});
